import { useEffect, useState } from "react";
import Button from "src/Components/Button";
import Loading from "src/Components/Loading/Loading";
import { IDeltaOptions } from "src/Interfaces/automaticMarketMakingDelta";
import { getDeltaOptions } from "src/Requests/automaticMarketMakingDelta";
import { packetErrorHandler } from "src/Utils/requestUtils";
import { numberText } from "./DeltaTables";

const BlackScholesParameters = () => {
  const [parameters, setParameters] = useState<IDeltaOptions["parameters"]>();
  const [loading, setLoading] = useState(true);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    getDeltaOptions({ signal: controller.signal }).then((result) => {
      if (!controller.signal.aborted) setParameters(result.parameters);
    }).catch((error) => {
      if (!controller.signal.aborted) packetErrorHandler(error);
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [retry]);

  return <div className="flex flex-col gap-5 p-6 w-[480px] max-w-[calc(100vw-32px)]" dir="rtl">
    <div className="border-b border-slate-200 pb-4">
      <h2 className="text-base font-bold text-slate-800 pr-6">پارامترهای بلک شولز</h2>
    </div>
    {loading ? <div className="flex justify-center py-6"><Loading className="!text-sky-600" /></div> : parameters ? <>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div className="flex items-center gap-3 rounded-xl border border-sky-100 bg-sky-50 px-4 py-3">
          <span className="text-sm font-medium text-sky-800">نرخ بهره کال</span>
          <span className="text-xl font-bold text-sky-700 tabular-nums" dir="ltr">{numberText(parameters.callInterestRatePercent, 2)}%</span>
        </div>
        <div className="flex items-center gap-3 rounded-xl border border-sky-100 bg-sky-50 px-4 py-3">
          <span className="text-sm font-medium text-sky-800">نرخ بهره پوت</span>
          <span className="text-xl font-bold text-sky-700 tabular-nums" dir="ltr">{numberText(parameters.putInterestRatePercent, 2)}%</span>
        </div>
      </div>
      <div className="overflow-hidden rounded-xl border border-slate-200">
        <div className="max-h-[50vh] overflow-y-auto">
          <table className="text-sm w-full text-right">
            <thead className="sticky top-0 bg-slate-50 text-slate-600"><tr>
              <th className="px-4 py-3 font-bold">نماد پایه</th>
              <th className="px-4 py-3 font-bold text-center">نوسان‌پذیری (%)</th>
            </tr></thead>
            <tbody>{parameters.underlyings.map((item) => <tr key={item.instrumentId} className="border-t border-slate-100 hover:bg-sky-50/50">
              <td className="px-4 py-3 font-medium text-slate-800">{item.name}</td>
              <td className="px-4 py-3 text-center"><span className="inline-block min-w-[72px] rounded-md bg-slate-100 px-3 py-1 font-semibold text-slate-700 tabular-nums" dir="ltr">{numberText(item.volatilityPercent, 2)}</span></td>
            </tr>)}</tbody>
          </table>
          {parameters.underlyings.length === 0 && <p className="p-4 text-center text-sm text-slate-500">نمادی برای نمایش وجود ندارد.</p>}
        </div>
      </div>
    </> : <Button text="تلاش مجدد" variant="outlined" onClick={() => setRetry((value) => value + 1)} />}
  </div>;
};

export default BlackScholesParameters;
